/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Log_SetInputs */

const en_us2_workout_log_set = /** @type {(inputs: Workout_Log_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log set`)
};

const pt_br2_workout_log_set = /** @type {(inputs: Workout_Log_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar série`)
};

const es_419_workout_log_set = /** @type {(inputs: Workout_Log_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar serie`)
};

const pt_pt2_workout_log_set = /** @type {(inputs: Workout_Log_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registar série`)
};

const fr_fr2_workout_log_set = /** @type {(inputs: Workout_Log_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valider la série`)
};

const de_de2_workout_log_set = /** @type {(inputs: Workout_Log_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satz erfassen`)
};

const it_it2_workout_log_set = /** @type {(inputs: Workout_Log_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra serie`)
};

/**
* | output |
* | --- |
* | "Log set" |
*
* @param {Workout_Log_SetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_log_set = /** @type {((inputs?: Workout_Log_SetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Log_SetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_log_set(inputs)
	if (locale === "es-419") return es_419_workout_log_set(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_log_set(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_log_set(inputs)
	if (locale === "de-DE") return de_de2_workout_log_set(inputs)
	if (locale === "it-IT") return it_it2_workout_log_set(inputs)
	return en_us2_workout_log_set(inputs)
});
export { workout_log_set as "workout.log_set" }